import { render } from "./b.vue?vue&type=template&id=39a1768a&lang=pug"
import script from "./b.vue?vue&type=script&lang=js"
export * from "./b.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__